import { useNavigate, useParams } from 'react-router-dom'

import { TwoColumnLayout } from '@factorialco/f0-react'
import { QuotePricingPageDocument, QuotesTabsVisibilityDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { useConvertQuoteIntoInvoice } from 'modules/finance/hooks/quotes/useConvertQuoteIntoInvoice'
import { useCreateProjectFromQuote } from 'modules/finance/hooks/quotes/useCreateProjectFromQuote'
import { useDownloadQuotePdf } from 'modules/finance/hooks/quotes/useDownloadQuotePdf'
import { onHeaderActionClick } from 'modules/finance/lib/quotesUtils'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const QuotePricingPage = () => {
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const { quoteId } = useParams()
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const downloadQuotePdf = useDownloadQuotePdf()
  const convertQuoteIntoInvoice = useConvertQuoteIntoInvoice({
    refetchQueries: [QuotesTabsVisibilityDocument],
  })
  const createProjectFromQuote = useCreateProjectFromQuote({
    refetchQueries: [QuotesTabsVisibilityDocument],
  })
  const navigateToProject = () => {
    quote?.projectId &&
      navigate(
        navigation.projects.id.details.overview.fullPath({
          id: String(quote.projectId),
        })
      )
  }
  const navigateToInvoice = () => {
    quoteFinancialDocumentId &&
      navigate(
        navigation.finance.sales.salesInvoices.detail.fullPath({
          invoiceId: Number(quoteFinancialDocumentId),
        })
      )
  }

  const { data, error, loading } = useQuery(QuotePricingPageDocument, {
    variables: {
      companyId,
      id: Number(quoteId),
    },
  })
  const hasQuickQuoteBuilderFeature = !!data?.features.featuresConnection.nodes.find(
    (feature) => feature.name === 'dev_quick_quote_builder'
  )?.enabled
  const quote = data?.finance?.quote
  const quoteFinancialDocumentId = quote?.financialDocumentAssociation?.financialDocument?.id

  return (
    <ResponsivePage.Body
      variant="fullscreen"
      authorized={hasQuickQuoteBuilderFeature}
      loading={loading}
      error={error}
      onActionClick={(key) =>
        onHeaderActionClick(
          key,
          Number(quoteId),
          createProjectFromQuote,
          convertQuoteIntoInvoice,
          downloadQuotePdf,
          navigateToProject,
          navigateToInvoice
        )
      }
    >
      <TwoColumnLayout sideContent={<>Sidecontent</>}>Table</TwoColumnLayout>
    </ResponsivePage.Body>
  )
}

export default QuotePricingPage
